export const isBrowser = () => ![typeof window, typeof document].includes("undefined");
export const isNode = () => typeof process !== "undefined" && !!process.versions && !!process.versions.node;

export const strToUint8Array = async (data: string) => {
  if (isBrowser()) {
    return Uint8Array.from(atob(data), (c) => c.charCodeAt(0));
  }
  const Buff = Buffer || (await import("buffer")).Buffer;
  return Buff.from(data, "base64");
};

export const scaleIntoBox = (
  imageDimension: { width: number; height: number },
  container: { width: number; height: number }
) => {
  const boxWidth = container.width;
  const boxHeight = container.height;

  let scaledHeight = boxHeight;
  let scaledWidth = boxWidth;

  if (imageDimension.height / boxHeight > imageDimension.width / boxWidth) {
    scaledHeight = boxHeight;
    scaledWidth = imageDimension.width / (imageDimension.height / boxHeight);
  } else if (imageDimension.height / boxHeight < imageDimension.width / boxWidth) {
    scaledHeight = imageDimension.height / (imageDimension.width / boxWidth);
    scaledWidth = boxWidth;
  }
  return { width: scaledWidth, height: scaledHeight };
};

export const isRTL = function (text: string) {
  const rtlChars = "\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC";
  const rtlDirCheck = new RegExp("^[^" + rtlChars + "]*?[" + rtlChars + "]");

  return rtlDirCheck.test(text);
};
